module.exports = __webpack_public_path__ + "img/diving-board-pool--icon--gray.9f4597e3.svg";